<template>
  <component :is="componentName" :block="block" />
</template>

<script>
import TextBlock from './TextBlock.vue'
import RichTextBlock from './RichTextBlock.vue'
import ImageBlock from './ImageBlock.vue'
import VideoBlock from './VideoBlock.vue'
import FileBlock from './FileBlock.vue'
import GalleryBlock from './GalleryBlock.vue'
import DividerBlock from './DividerBlock.vue'

const BLOCK_TYPE_MAP = {
  text: 'RichTextBlock',
  richtext: 'RichTextBlock',
  richText: 'RichTextBlock',
  image: 'ImageBlock',
  video: 'VideoBlock',
  file: 'FileBlock',
  attachment: 'FileBlock',
  gallery: 'GalleryBlock',
  album: 'GalleryBlock',
  divider: 'DividerBlock'
}

export default {
  name: 'BlockRenderer',
  components: {
    TextBlock,
    RichTextBlock,
    ImageBlock,
    VideoBlock,
    FileBlock,
    GalleryBlock,
    DividerBlock
  },
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  computed: {
    componentName() {
      const blockType = (this.block && this.block.blockType) || ''
      return BLOCK_TYPE_MAP[blockType] || 'TextBlock'
    }
  }
}
</script>
